import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { ClinicianAppBarComponent } from '@shareview-health/clinician/shared';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map } from 'rxjs';

@Component({
  imports: [
    RouterModule,
    MatButton,
    NgOptimizedImage,
    AsyncPipe,
    ClinicianAppBarComponent,
  ],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly oidcSecurityService = inject(OidcSecurityService);

  protected readonly isAuthenticated$ =
    this.oidcSecurityService.isAuthenticated$.pipe(
      map((result) => result.isAuthenticated)
    );

  protected login(): void {
    this.oidcSecurityService.authorize();
  }

  protected logout(): void {
    this.oidcSecurityService.logoffAndRevokeTokens().subscribe();
  }
}
